import React from "react";
import { Modal, Button } from "react-bootstrap";
import { FaCamera } from "react-icons/fa";
const ProcessingPlantGallery = ({ images, onCameraClick }) => {
  if (!images || images.length < 4) return null;

  return (
    <div className="container-fluid">
      <div className="row">
        {/* Right: 2x2 smaller images */}
        <div className="col-md-12 d-grid gap-2">
          <div className="row g-2">
            {images.slice(0, 4).map((img, idx) => (
              <div key={idx} className="col-6">
                <img
                  src={img}
                  alt={`Sub ${idx + 1}`}
                  className="img-fluid rounded w-100"
                  style={{ objectFit: "cover" }}
                />
                <Button
                  variant=""
                  size="sm"
                  className="me-2"
                  style={{
                    color: "white",
                    position: "absolute",
                    bottom: "0px",
                    right: "-5px",
                    backgroundColor: "transparent !important",
                    border: "none",
                    fontSize: "1.5rem",
                  }}
                  onClick={() => onCameraClick(idx + 1)}
                >
                  <FaCamera className="me-1" />
                </Button>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProcessingPlantGallery;
